export function getMarkupBoundingClientRect(element: HTMLElement): DOMRect {
  return element.getBoundingClientRect();
}
